// @flow
import Errors, { NetworkingError } from 'lib/errors';

export default function(promiseFn: (...args: Array<*>) => fetch) {
  return (...args: Array<*>) => {
    return promiseFn(...args).catch((err: Error) =>
      Promise.reject(Errors.isHttpError(err) ? err : new NetworkingError())
    );
  };
}



// WEBPACK FOOTER //
// ./src/api/wrapWithNetworkError.js